export default __webpack_public_path__ + "static/simple-scatter-84a7e4114d1818da06acaed5b7336d09.png";